'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports = module.exports = function () {
  function Template() {
    _classCallCheck(this, Template);
  }

  _createClass(Template, null, [{
    key: 'safeHTML',
    value: function safeHTML(templateData) {
      var str = templateData[0];
      for (var i = 1; i < arguments.length; i++) {
        var arg = String(arguments[i]);
        str += arg.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        str += templateData[i];
      }
      return s;
    }
  }, {
    key: 'render',
    value: function render(numbani) {
      var tmpl = numbani.template,
          data = numbani.data;
      return tmpl.call(null, data);
    }
  }, {
    key: 'iterate',
    value: function iterate(numbani) {
      var tmpl = numbani.template,
          data = numbani.data,
          result = [];
      data.forEach(function (item, idx) {
        result.push(tmpl.call(null, item));
      });
      return result.join('');
    }
  }, {
    key: 'conditional',
    value: function conditional(condition, numbani1, numbani2) {
      return condition ? numbani1 : numbani2;
    }
  }, {
    key: 'encode',
    value: function encode(numbani) {
      return encodeURIComponent(numbani);
    }
  }, {
    key: 'join',
    value: function join() {
      for (var _len = arguments.length, numbani = Array(_len), _key = 0; _key < _len; _key++) {
        numbani[_key] = arguments[_key];
      }

      return numbani.join('');
    }
  }, {
    key: 'concat',
    value: function concat() {
      for (var _len2 = arguments.length, numbani = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        numbani[_key2] = arguments[_key2];
      }

      return numbani.join('');
    }
  }, {
    key: 'escape',
    value: function escape(numbani) {
      return numbani.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/`/g, '&#96;');
    }
  }]);

  return Template;
}();